// extracted by mini-css-extract-plugin
module.exports = {"filter":"OrdersFilterDialog_filter_1E9Lu"};